import { formatShortDateTime, formatTime, toYmd } from '../../utils/datetime';

/** The funnel, in order. CONVERTED is reached only through "O'quvchiga aylantirish". */
export const LEAD_STATUSES = ['NEW', 'CONTACTED', 'INTERESTED', 'PAYMENT_PENDING', 'CONVERTED', 'LOST'];
export const EDITABLE_STATUSES = LEAD_STATUSES.filter((s) => s !== 'CONVERTED');

export const STATUS_TONE = {
  NEW: 'info',
  CONTACTED: 'purple',
  INTERESTED: 'brand',
  PAYMENT_PENDING: 'warning',
  CONVERTED: 'success',
  LOST: 'neutral',
};

export const CALL_OUTCOMES = ['REACHED', 'NO_ANSWER', 'BUSY', 'CALL_BACK', 'WRONG_NUMBER', 'NOT_INTERESTED'];

export const OUTCOME_TONE = {
  REACHED: 'success',
  NO_ANSWER: 'neutral',
  BUSY: 'warning',
  CALL_BACK: 'info',
  WRONG_NUMBER: 'danger',
  NOT_INTERESTED: 'coral',
};

/** The status a call outcome suggests (the person can still pick another). */
export const OUTCOME_SUGGESTS = { NOT_INTERESTED: 'LOST', WRONG_NUMBER: 'LOST' };

const SOURCE_KEYS = { landing: 'landing', 'crm-register': 'crmRegister', manual: 'manual' };

/** "Sayt" · "CRM so'rovi" · "Qo'lda qo'shilgan"; another source shows as the business typed it. */
export function sourceLabel(t, source) {
  if (!source) return '—';
  const key = SOURCE_KEYS[source];
  return key ? t(`leads.source.${key}`) : source;
}

/** The person's name, else their number. */
export function leadName(lead) {
  return (lead && (lead.name || [lead.firstName, lead.lastName].filter(Boolean).join(' '))) || lead?.phoneNumber || '';
}

/** 'overdue' (the time has passed), 'today', 'later' or null (no call planned). */
export function callState(nextCallAt, now = new Date()) {
  if (!nextCallAt) return null;
  const at = new Date(nextCallAt);
  if (Number.isNaN(at.getTime())) return null;
  if (at <= now) return 'overdue';
  return toYmd(at) === toYmd(now) ? 'today' : 'later';
}

/** "Bugun, 15:00" · "Ertaga, 10:00" · "21-okt, 10:00" (24-hour, the staff member's clock). */
export function formatCallTime(t, value, now = new Date()) {
  if (!value) return '—';
  const at = new Date(value);
  if (Number.isNaN(at.getTime())) return '—';
  const tomorrow = new Date(now);
  tomorrow.setDate(tomorrow.getDate() + 1);
  if (toYmd(at) === toYmd(now)) return `${t('leads.filters.dueToday')}, ${formatTime(at)}`;
  if (toYmd(at) === toYmd(tomorrow)) return `${t('leads.call.tomorrow')}, ${formatTime(at)}`;
  return formatShortDateTime(at, { year: 'auto' });
}

/** A picked day ("YYYY-MM-DD") and time ("HH:MM") as the ISO instant the API takes, or null. */
export function toInstant(ymd, hhmm) {
  if (!ymd) return null;
  const [y, m, d] = ymd.split('-').map(Number);
  const [hh, mm] = (hhmm || '10:00').split(':').map(Number);
  const at = new Date(y, m - 1, d, hh, mm, 0, 0);
  return Number.isNaN(at.getTime()) ? null : at.toISOString();
}

/** The local day and time of an instant, for the pickers: { date: "YYYY-MM-DD", time: "HH:MM" }. */
export function fromInstant(value) {
  if (!value) return { date: '', time: '' };
  const at = new Date(value);
  if (Number.isNaN(at.getTime())) return { date: '', time: '' };
  return { date: toYmd(at) || '', time: formatTime(at) };
}

/** The day `days` from today, as "YYYY-MM-DD". */
export function dayFromToday(days, now = new Date()) {
  const at = new Date(now);
  at.setDate(at.getDate() + days);
  return toYmd(at) || '';
}
